import React from 'react';
import Radium from 'radium';
import { func, bool, number } from 'prop-types';
import { UTButton } from '@widergy/energy-ui';

import UTTable from '../../../../../../components/UTTable';
import { accountsActiveRowSize, inactiveRowSize } from '../../../../../../../constants/sizes';
import { accountPropTypes } from '../../../../../../../redux/accountHandlers';
import { formPropType } from '../../../../../../../redux/userFormHandlers';
import { DefaultViewport, MobileViewport } from '../../../../../../../constants/deviceSizes';
import { appConfig } from '../../../../../../../config/customization';
import { message } from '../../../../../../../utils/stringUtils';

import AccountDetails from './components/AccountDetails';
import DeleteAccount from './components/DeleteAccount';
import AccountsMobileTable from './components/AccountsMobileTable';
import styles from './styles';

const columns = [
  { key: 'client_number', name: message('Accounts:clientNumber'), width: 0.12 },
  { key: 'holder_name', name: message('Accounts:holderName'), width: 0.3 },
  { key: 'address', name: message('Accounts:address'), width: 0.3 }
];

/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */

const associateButtonRenderer = (onAssociateModalOpen, accounts) => ({ rowData }) =>
  appConfig.addSupplies && rowData.related_accounts ? (
    <div style={styles.associateContainer}>
      <UTButton
        onPress={() => onAssociateModalOpen(rowData.client_number, accounts.relatedAccounts)}
        textstyle={styles.associateButtonText}
        style={styles.associateButton}
      >
        {message('Accounts:associate')}
      </UTButton>
    </div>
  ) : null;

function AccountList({
  accounts,
  onReturn,
  onDeleteAccount,
  deleteModalIsOpen,
  onDeleteModalOpen,
  onDeleteModalClose,
  deleteAccountId,
  automaticDebitForm,
  digitalBillForm,
  onAssociateModalOpen,
  deleteAccountLoading,
  onRowsRendered,
  onClick
}) {
  return (
    <div style={styles.container}>
      <DefaultViewport>
        <div style={styles.table}>
          <UTTable
            columns={
              appConfig.addSupplies
                ? [
                    ...columns,
                    {
                      key: 'associate',
                      name: message('Accounts:relatedAccounts'),
                      width: 0.2,
                      cellRenderer: associateButtonRenderer(onAssociateModalOpen, accounts)
                    }
                  ]
                : columns
            }
            rows={accounts}
            openable
            id={message('Accounts:accounts')}
            renderActiveRow={(rowData, positionStyle) => (
              <AccountDetails
                automaticDebitForm={automaticDebitForm}
                digitalBillForm={digitalBillForm}
                rowData={rowData}
                style={positionStyle}
                onDeleteModalOpen={onDeleteModalOpen}
              />
            )}
            activeRowStyle={styles.activeRowStyle}
            rowHeight={(index, activeRowIndex) =>
              index === activeRowIndex ? accountsActiveRowSize : inactiveRowSize
            }
            scrolleable
            onRowsRendered={onRowsRendered}
          />
        </div>
      </DefaultViewport>
      <MobileViewport>
        <AccountsMobileTable
          digitalBillForm={digitalBillForm}
          automaticDebitForm={automaticDebitForm}
          accounts={accounts}
          onReturn={onReturn}
          onDeleteModalOpen={onDeleteModalOpen}
          onAssociateModalOpen={onAssociateModalOpen}
          onRowsRendered={onRowsRendered}
          onClick={onClick}
          style={{
            associateTextStyle: styles.associateButtonText,
            associateButton: styles.associateButtonMobile
          }}
        />
      </MobileViewport>
      {appConfig.deleteAccount && (
        <DeleteAccount
          deleteModalIsOpen={deleteModalIsOpen}
          onDeleteModalClose={onDeleteModalClose}
          onDeleteAccount={onDeleteAccount}
          deleteAccountId={deleteAccountId}
          deleteAccountLoading={deleteAccountLoading}
        />
      )}
    </div>
  );
}

AccountList.propTypes = {
  accounts: accountPropTypes,
  onReturn: func.isRequired,
  onDeleteAccount: func.isRequired,
  deleteModalIsOpen: bool.isRequired,
  onDeleteModalOpen: func.isRequired,
  onDeleteModalClose: func.isRequired,
  deleteAccountId: number,
  automaticDebitForm: formPropType,
  digitalBillForm: formPropType,
  onAssociateModalOpen: func,
  onClick: func,
  deleteAccountLoading: bool
};

export default Radium(AccountList);
